import { Theme } from "apps/website/maps/Theme.map";
import { Padding } from "apps/website/maps/Spacing.map";

import { IIcon } from "../../base/Icon/Icon";
import { iconSvgMap } from "../../base/Icon/Icon.map";
import { illustrationSvgMap } from "../../base/Illustration/illustration.map";
import { IIllustration } from "../../base/Illustration/Illustration";
import { IImageProps } from "../../base/Image/Image";

export type TEducationalIllustrationName = keyof typeof educationalIllustrationMap;

export type TFunctionalIconName = keyof typeof functionalIconMap;

interface IEducationalIllustrationProp extends IIllustration {
  illustration: TEducationalIllustrationName
}

export interface IFunctionalIconProp extends IIcon {
  icon: TFunctionalIconName
}

export const educationalIllustrationMap = {
  superCat: illustrationSvgMap.superCat,
  joinTheClub: illustrationSvgMap.joinTheClub,
  badBacteria: illustrationSvgMap.badBacteria,
  moreRealMeat: illustrationSvgMap.moreRealMeat,
  moreMeatForLess: illustrationSvgMap.moreMeatForLess,
  coins: illustrationSvgMap.coins,
  doctorCat: illustrationSvgMap.doctorCat,
  eatsAnything: illustrationSvgMap.eatsAnything,
  canBeFussy: illustrationSvgMap.canBeFussy,
  hardToPlease: illustrationSvgMap.hardToPlease,
  kittenAge: illustrationSvgMap.kittenAge,
  adultAge: illustrationSvgMap.adultAge,
  seniorAge: illustrationSvgMap.seniorAge,
  emptyBowl: illustrationSvgMap.emptyBowl,
  happyHealthyCat: illustrationSvgMap.happyHealthyCat,
  fullCat: illustrationSvgMap.fullCat,
};

export const functionalIconMap = {
  warningBold: iconSvgMap.warningBold,
  crossInverted: iconSvgMap.crossInverted,
  tickInverted: iconSvgMap.tickInverted,
  informationHeavy: iconSvgMap.informationHeavy,
  currency: iconSvgMap.currency,
  pauseCircled: iconSvgMap.pauseCircled,
  traysCircled: iconSvgMap.traysCircled,
  snowflakeCircled: iconSvgMap.snowflakeCircled,
  lightBulb: iconSvgMap.lightBulb,
  lockOpen: iconSvgMap.lockOpen,
  leaf: iconSvgMap.leaf,
};

export type TComponent = "educational" | "functional";

export interface IStyleOptions {
  backgroundColor?: Theme
  padding?: Padding
  paddingTop?: Padding
  paddingBottom?: Padding
  paddingLeft?: Padding
  paddingRight?: Padding
}

export interface IMessaging {
  title?: string
  description: React.ReactNode
  component: TComponent
  styleOptions?: IStyleOptions
  id?: string
}

export interface IEducationalCard extends IMessaging {
  component: "educational";
  image?: IImageProps,
  illustration?: IEducationalIllustrationProp,
  titleTag?: string,
  footer?: string
}

export interface IFunctionalCard extends IMessaging {
  component: "functional";
  icon?: IFunctionalIconProp
}

export type TMessagingCard = IEducationalCard | IFunctionalCard;

export const isMessagingCard = (element: unknown): element is TMessagingCard => {
  const component = (element as TMessagingCard | null)?.component;
  return component === "educational" || component === "functional";
};

export const componentPaddingMap: Record<TComponent, Required<Pick<IStyleOptions, "paddingTop" | "paddingBottom" | "paddingLeft" | "paddingRight">>> = {
  educational: {
    paddingLeft: 3,
    paddingBottom: 3,
    paddingRight: 3,
    paddingTop: 3,
  },
  functional: {
    paddingBottom: 4,
    paddingLeft: 3,
    paddingRight: 3,
    paddingTop: 3,
  },
};
